/**
 * Do not edit directly
 * Generated on Mon, 26 Oct 2026 08:05:03 GMT
 */

export const BreakpointExtraSmall = "426px";
export const BreakpointSmall = "768px";
export const BreakpointMedium = "1024px";
export const BreakpointLarge = "1280px";
export const BreakpointExtraLarge = "1680px";
export const ColorWhite = "#ffffff";
export const ColorBlack = "#000000";
export const ColorGrey100 = "#f5f5f5";
export const ColorGrey200 = "#dadada";
export const ColorGrey300 = "#adadad";
export const ColorGrey400 = "#999999";
export const ColorGrey500 = "#858585";
export const ColorGrey600 = "#5c5c5c";
export const ColorGrey700 = "#474747";
export const ColorGrey800 = "#333333";
export const ColorGrey900 = "#242424";
export const ColorGrey1000 = "#141414";
export const ColorRed100 = "#fae8ea";
export const ColorRed200 = "#f0b9c0";
export const ColorRed300 = "#e78b95";
export const ColorRed400 = "#df6876";
export const ColorRed500 = "#d94c5d";
export const ColorRed600 = "#ce172c";
export const ColorRed700 = "#a41d22";
export const ColorRed800 = "#710d18";
export const ColorRed900 = "#4c0910";
export const ColorRed1000 = "#2d050a";
export const ColorGreen100 = "#e5f8ed";
export const ColorGreen200 = "#a6d7b9";
export const ColorGreen300 = "#73c090";
export const ColorGreen400 = "#33a35e";
export const ColorGreen500 = "#1a974a";
export const ColorGreen600 = "#007e31";
export const ColorGreen700 = "#006226";
export const ColorGreen800 = "#004d1e";
export const ColorGreen900 = "#003515";
export const ColorGreen1000 = "#00220d";
export const ColorBlue100 = "#e5f4fb";
export const ColorBlue200 = "#b2def2";
export const ColorBlue300 = "#73c2e7";
export const ColorBlue400 = "#33a6dd";
export const ColorBlue500 = "#0090d4";
export const ColorBlue600 = "#0070a5";
export const ColorBlue700 = "#004e6d";
export const ColorBlue800 = "#003d55";
export const ColorBlue900 = "#003042";
export const ColorBlue1000 = "#001f2c";
export const ColorOrange100 = "#fceacc";
export const ColorOrange200 = "#fbdfb2";
export const ColorOrange300 = "#f7bf66";
export const ColorOrange400 = "#f5a933";
export const ColorOrange500 = "#f29400";
export const ColorOrange600 = "#da8500";
export const ColorOrange700 = "#c27600";
export const ColorOrange800 = "#a76600";
export const ColorOrange900 = "#613b00";
export const ColorOrange1000 = "#2c1b00";
export const ColorPurple100 = "#f0e8f9";
export const ColorPurple200 = "#ddcdf2";
export const ColorPurple300 = "#bb9be5";
export const ColorPurple400 = "#aa81de";
export const ColorPurple500 = "#9b6bd8";
export const ColorPurple600 = "#6f2ac7";
export const ColorPurple700 = "#5504bd";
export const ColorPurple800 = "#4903a1";
export const ColorPurple900 = "#3c0384";
export const ColorPurple1000 = "#260253";
export const ColorPink100 = "#fce8ef";
export const ColorPink200 = "#f7b5cc";
export const ColorPink300 = "#f0739e";
export const ColorPink400 = "#eb4d84";
export const ColorPink500 = "#e93372";
export const ColorPink600 = "#d30063";
export const ColorPink700 = "#b60055";
export const ColorPink800 = "#880040";
export const ColorPink900 = "#5b002a";
export const ColorPink1000 = "#320016";
export const ColorTeal100 = "#e9f6f7";
export const ColorTeal200 = "#c7e8eb";
export const ColorTeal300 = "#8fd1d6";
export const ColorTeal400 = "#69c2c9";
export const ColorTeal500 = "#3d9fa6";
export const ColorTeal600 = "#2e7a7f";
export const ColorTeal700 = "#27686c";
export const ColorTeal800 = "#1f5154";
export const ColorTeal900 = "#183f41";
export const ColorTeal1000 = "#0c2022";
export const ColorBeige100 = "#f9f7f3";
export const ColorBeige200 = "#f4f0e8";
export const ColorBeige300 = "#eae3d6";
export const ColorBeige400 = "#dbd0bf";
export const ColorBeige500 = "#938b80";
export const ColorBeige600 = "#6b6a66";
export const ColorBeige700 = "#5f5e5a";
export const ColorBeige800 = "#4c4a48";
export const ColorBeige900 = "#333231";
export const ColorBeige1000 = "#131312";
export const ColorNeutral100 = "#f5f5f5";
export const ColorNeutral200 = "#dadada";
export const ColorNeutral300 = "#adadad";
export const ColorNeutral400 = "#999999";
export const ColorNeutral500 = "#858585";
export const ColorNeutral600 = "#5c5c5c";
export const ColorNeutral700 = "#474747";
export const ColorNeutral800 = "#333333";
export const ColorNeutral900 = "#242424";
export const ColorNeutral1000 = "#141414";
export const ColorPrimary100 = "#e5f4fb";
export const ColorPrimary200 = "#b2def2";
export const ColorPrimary300 = "#73c2e7";
export const ColorPrimary400 = "#33a6dd";
export const ColorPrimary500 = "#0090d4";
export const ColorPrimary600 = "#0070a5";
export const ColorPrimary700 = "#004e6d";
export const ColorPrimary800 = "#003d55";
export const ColorPrimary900 = "#003042";
export const ColorPrimary1000 = "#001f2c";
export const ColorSuccess100 = "#e5f8ed";
export const ColorSuccess200 = "#a6d7b9";
export const ColorSuccess300 = "#73c090";
export const ColorSuccess400 = "#33a35e";
export const ColorSuccess500 = "#1a974a";
export const ColorSuccess600 = "#007e31";
export const ColorSuccess700 = "#006226";
export const ColorSuccess800 = "#004d1e";
export const ColorSuccess900 = "#003515";
export const ColorSuccess1000 = "#00220d";
export const ColorWarning100 = "#fae8ea";
export const ColorWarning200 = "#f0b9c0";
export const ColorWarning300 = "#e78b95";
export const ColorWarning400 = "#df6876";
export const ColorWarning500 = "#d94c5d";
export const ColorWarning600 = "#ce172c";
export const ColorWarning700 = "#a41d22";
export const ColorWarning800 = "#710d18";
export const ColorWarning900 = "#4c0910";
export const ColorWarning1000 = "#2d050a";
export const ElevationShadowSunken = "2px 2px 4px 0px rgb(0 0 0 / 0.15) inset";
export const ElevationShadowDefault = "none";
export const ElevationShadowRaised = "2px 2px 2px 0px rgb(0 0 0 / 0.15)";
export const ElevationShadowOverlay = "0 6px 12px rgb(0 0 0 / 0.1), 0 4px 6px rgb(0 0 0 / 0.06), 0 0 1px rgb(0 0 0 / 0.15)";
export const ElevationBackdropColor = "#000000";
export const FocusRingColor = "#0090d4";
export const FocusRingOffset = "2rem";
export const FocusRingStyle = "solid";
export const FocusRingWidth = "3rem";
export const FontFamilyProximaNova = "'proxima-nova', Arial, sans-serif";
export const FontFamilyCaeciliaLtPro = "'caecilia', serif";
export const FontFamilyNotoSans = "'Noto Sans', sans-serif";
export const FontUrlProximaNovaCaeciliaLtPro = "'https://use.typekit.net/snp8vmp.css'";
export const FontUrlNotoSans = "'https://fonts.googleapis.com/css2?family=Noto+Sans:ital,wght@0,100..900;1,100..900&display=swap'";
export const FontWeightWeight300 = "300";
export const FontWeightWeight400 = "400";
export const FontWeightWeight600 = "600";
export const FontWeightWeight700 = "700";
export const IconSizeDefault = "1em";
export const IconSizeSmall = "12rem";
export const IconSizeMedium = "20rem";
export const IconSizeLarge = "24rem";
export const IconSizeLarger = "28rem";
export const IconSizeLargest = "32rem";
export const Number9 = "9rem";
export const Number12 = "12rem";
export const Number14 = "14rem";
export const Number15 = "15rem";
export const Number16 = "16rem";
export const Number18 = "18rem";
export const Number20 = "20rem";
export const Number22 = "22rem";
export const Number24 = "24rem";
export const Number26 = "26rem";
export const Number28 = "28rem";
export const Number32 = "32rem";
export const Number33 = "33rem";
export const Number34 = "34rem";
export const Number35 = "35rem";
export const Number38 = "38rem";
export const Number40 = "40rem";
export const Number64 = "64rem";
export const Number133 = "13.3rem";
export const Number175 = "17.5rem";
export const Number187 = "18.7rem";
export const Number189 = "18.9rem";
export const Number216 = "21.6rem";
export const Number231 = "23.1rem";
export const Number243 = "24.3rem";
export const Number253 = "25.3rem";
export const Number264 = "26.4rem";
export const Number297 = "29.7rem";
export const Number425 = "42.5rem";
export const Number475 = "47.5rem";
export const PageSizeWidth = "215mm";
export const PagePaddingTop = "64rem";
export const PagePaddingBottom = "40rem";
export const PagePaddingLeft = "14rem";
export const PagePaddingRight = "14rem";
export const RadiusNone = "0rem";
export const RadiusSmall = "4rem";
export const RadiusMedium = "8rem";
export const RadiusSpecial = "10rem";
export const RadiusLarge = "12rem";
export const RadiusExtraLarge = "24rem";
export const RadiusFull = "999rem";
export const SpacingSpace0 = "0rem";
export const SpacingSpace25 = "2rem";
export const SpacingSpace50 = "4rem";
export const SpacingSpace75 = "6rem";
export const SpacingSpace100 = "8rem";
export const SpacingSpace150 = "12rem";
export const SpacingSpace200 = "16rem";
export const SpacingSpace250 = "20rem";
export const SpacingSpace275 = "22rem";
export const SpacingSpace300 = "24rem";
export const SpacingSpace350 = "28rem";
export const SpacingSpace400 = "32rem";
export const SpacingSpace500 = "40rem";
export const SpacingSpace600 = "48rem";
export const SpacingSpace800 = "64rem";
export const SpacingSpace1000 = "80rem";
export const TextAlignLeft = "left";
export const TextAlignCenter = "center";
export const TextAlignRight = "right";
export const TextAlignJustify = "justify";
export const TextStyleNormal = "normal";
export const TextStyleItalic = "italic";
export const TextStyleOblique = "oblique";
export const TextDecorationNone = "none";
export const TextDecorationUnderline = "underline";
export const TextDecorationOverline = "overline";
export const TextDecorationLineThrough = "line-through";
export const TransitionDurationExtraFast = "0.1s";
export const TransitionDurationFast = "0.2s";
export const TransitionDurationNormal = "0.3s";
export const TransitionDurationSlow = "0.4s";
export const TransitionDurationExtraSlow = "0.5s";
export const TransitionFunctionEaseIn = "cubic-bezier(0.42, 0, 1, 1)";
export const TransitionFunctionEaseOut = "cubic-bezier(0, 0, 0.58, 1)";
export const TransitionFunctionEaseInOut = "cubic-bezier(0.42, 0, 0.58, 1)";
export const TypographyFontFamily = "Arial";
export const TypographyLabelSmallSize = "12rem";
export const TypographyLabelSmallLineHeight = 1.25;
export const TypographyLabelSmallWeight = 400;
export const TypographyLabelSmallTracking = 1;
export const TypographyLabelSmallLetterSpacing = 0;
export const TypographyLabelSmallStyle = "normal";
export const TypographyLabelSmallDecoration = "none";
export const TypographyLabelMediumSize = "14rem";
export const TypographyLabelMediumLineHeight = 1.25;
export const TypographyLabelMediumWeight = 400;
export const TypographyLabelMediumTracking = 1;
export const TypographyLabelMediumLetterSpacing = 0;
export const TypographyLabelMediumStyle = "normal";
export const TypographyLabelMediumDecoration = "none";
export const TypographyLabelLargeSize = "16rem";
export const TypographyLabelLargeLineHeight = 1.25;
export const TypographyLabelLargeWeight = 400;
export const TypographyLabelLargeTracking = 1;
export const TypographyLabelLargeLetterSpacing = 0;
export const TypographyLabelLargeStyle = "normal";
export const TypographyLabelLargeDecoration = "none";
export const TypographyBodySmallSize = "14rem";
export const TypographyBodySmallLineHeight = 1.65;
export const TypographyBodySmallWeight = 400;
export const TypographyBodySmallTracking = 1;
export const TypographyBodySmallLetterSpacing = 0;
export const TypographyBodySmallStyle = "normal";
export const TypographyBodySmallDecoration = "none";
export const TypographyBodyMediumSize = "16rem";
export const TypographyBodyMediumLineHeight = 1.65;
export const TypographyBodyMediumWeight = 400;
export const TypographyBodyMediumTracking = 1;
export const TypographyBodyMediumLetterSpacing = 0;
export const TypographyBodyMediumStyle = "normal";
export const TypographyBodyMediumDecoration = "none";
export const TypographyBodyLargeSize = "20rem";
export const TypographyBodyLargeLineHeight = 1.65;
export const TypographyBodyLargeWeight = 400;
export const TypographyBodyLargeTracking = 1;
export const TypographyBodyLargeLetterSpacing = 0;
export const TypographyBodyLargeStyle = "normal";
export const TypographyBodyLargeDecoration = "none";
export const TypographyNavSmallSize = "14rem";
export const TypographyNavSmallLineHeight = 1.35;
export const TypographyNavSmallWeight = 400;
export const TypographyNavSmallTracking = 1;
export const TypographyNavSmallLetterSpacing = 0;
export const TypographyNavSmallStyle = "normal";
export const TypographyNavSmallDecoration = "none";
export const TypographyNavMediumSize = "16rem";
export const TypographyNavMediumLineHeight = 1.35;
export const TypographyNavMediumWeight = 400;
export const TypographyNavMediumTracking = 1;
export const TypographyNavMediumLetterSpacing = 0;
export const TypographyNavMediumStyle = "normal";
export const TypographyNavMediumDecoration = "none";
export const TypographyNavLargeSize = "18rem";
export const TypographyNavLargeLineHeight = 1.35;
export const TypographyNavLargeWeight = 400;
export const TypographyNavLargeTracking = 1;
export const TypographyNavLargeLetterSpacing = 0;
export const TypographyNavLargeStyle = "normal";
export const TypographyNavLargeDecoration = "none";
export const TypographyHeadingSmallSize = "16rem";
export const TypographyHeadingSmallLineHeight = 1.35;
export const TypographyHeadingSmallWeight = 700;
export const TypographyHeadingSmallTracking = 1;
export const TypographyHeadingSmallLetterSpacing = 0;
export const TypographyHeadingSmallStyle = "normal";
export const TypographyHeadingSmallDecoration = "none";
export const TypographyHeadingMediumSize = "18rem";
export const TypographyHeadingMediumLineHeight = 1.35;
export const TypographyHeadingMediumWeight = 700;
export const TypographyHeadingMediumTracking = 1;
export const TypographyHeadingMediumLetterSpacing = 0;
export const TypographyHeadingMediumStyle = "normal";
export const TypographyHeadingMediumDecoration = "none";
export const TypographyHeadingLargeSize = "22rem";
export const TypographyHeadingLargeLineHeight = 1.35;
export const TypographyHeadingLargeWeight = 700;
export const TypographyHeadingLargeTracking = 1;
export const TypographyHeadingLargeLetterSpacing = 0;
export const TypographyHeadingLargeStyle = "normal";
export const TypographyHeadingLargeDecoration = "none";
export const TypographyDisplaySmallSize = "28rem";
export const TypographyDisplaySmallLineHeight = 1.25;
export const TypographyDisplaySmallWeight = 700;
export const TypographyDisplaySmallTracking = 1;
export const TypographyDisplaySmallLetterSpacing = 0;
export const TypographyDisplaySmallStyle = "normal";
export const TypographyDisplaySmallDecoration = "none";
export const TypographyDisplaySmallTabletSize = "24rem";
export const TypographyDisplayMediumSize = "34rem";
export const TypographyDisplayMediumLineHeight = 1.25;
export const TypographyDisplayMediumWeight = 700;
export const TypographyDisplayMediumTracking = 1;
export const TypographyDisplayMediumLetterSpacing = 0;
export const TypographyDisplayMediumStyle = "normal";
export const TypographyDisplayMediumDecoration = "none";
export const TypographyDisplayMediumTabletSize = "26rem";
export const TypographyDisplayLargeSize = "38rem";
export const TypographyDisplayLargeLineHeight = 1.25;
export const TypographyDisplayLargeWeight = 700;
export const TypographyDisplayLargeTracking = 1;
export const TypographyDisplayLargeLetterSpacing = 0;
export const TypographyDisplayLargeStyle = "normal";
export const TypographyDisplayLargeDecoration = "none";
export const TypographyDisplayLargeTabletSize = "34rem";
export const ZIndexBottom = -100;
export const ZIndexBase = 0;
export const ZIndexAboveContent = 1;
export const ZIndexToolbar = 2;
export const ZIndexSticky = 100;
export const ZIndexFixed = 200;
export const ZIndexToastNotification = 900;
export const ZIndexTop = 9000;
export const ZIndexStacking0 = 0;
export const ZIndexStacking1 = 1;
export const ZIndexStacking2 = 2;
export const ZIndexStacking3 = 3;
